(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.updateGlassHeader();
    }

    updateGlassHeader() {
      this.header.classList.toggle('leydi-glass-scrolled', window.scrollY > 10);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      this.updateGlassHeader();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leydi-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('leydi-hero-slideshow')) {
    customElements.define('leydi-hero-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const listen = (target, event, handler, options = {}) => target.addEventListener(event, handler, { ...options, signal: this.controller.signal });
        this.slides = Array.from(this.querySelectorAll('.leydi-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('.leydi-hero__dot'));
        this.toggle = this.querySelector('.leydi-hero__toggle');
        this.stage = this.querySelector('.leydi-hero__stage');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.busy = false;
        this.visible = true;
        this.hovered = false;
        this.userPaused = this.dataset.autoplay !== 'true' || this.motion.matches || Boolean(window.Shopify && Shopify.designMode);
        this.interval = Number(this.dataset.interval) || 6000;
        this.dots.forEach((dot, index) => listen(dot, 'click', () => this.go(index, true)));
        if (this.toggle) listen(this.toggle, 'click', () => { this.userPaused = !this.userPaused; this.schedule(); });
        listen(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
        listen(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
        listen(this, 'focusin', event => { if (event.target !== this.toggle) { this.userPaused = true; this.schedule(); } });
        listen(document, 'visibilitychange', () => this.schedule());
        listen(this.motion, 'change', () => { this.userPaused = this.motion.matches || this.userPaused; this.schedule(); });
        listen(this, 'keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
          }
        });
        listen(this.stage, 'pointerdown', event => {
          this.swiped = false;
          this.touchStart = event.pointerType === 'touch' ? { x: event.clientX, y: event.clientY } : null;
        }, { passive: true });
        listen(this.stage, 'pointerup', event => {
          if (!this.touchStart) return;
          const dx = event.clientX - this.touchStart.x;
          const dy = event.clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { this.swiped = true; this.go(this.index + (dx < 0 ? 1 : -1), true); }
        }, { passive: true });
        listen(this.stage, 'pointercancel', () => { this.touchStart = null; });
        listen(this.stage, 'click', event => { if (this.swiped) { event.preventDefault(); this.swiped = false; } }, { capture: true });
        listen(document, 'shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
          if (index >= 0) this.go(index, true, true);
        });
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.1 });
        this.observer.observe(this);
        this.classList.add('is-ready');
        this.schedule();
      }
      disconnectedCallback() {
        this.controller.abort();
        this.observer.disconnect();
        this.stop();
        this.querySelectorAll('*').forEach(element => element.getAnimations().forEach(animation => animation.cancel()));
      }
      stop() {
        clearTimeout(this.timer);
        if (this.progressAnimation) this.progressAnimation.cancel();
      }
      schedule() {
        this.stop();
        this.classList.toggle('is-paused', this.userPaused);
        if (this.toggle) this.toggle.setAttribute('aria-label', this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel);
        if (this.slides.length < 2 || this.userPaused || this.hovered || !this.visible || document.hidden || this.busy) return;
        const progress = this.dots[this.index].querySelector('.leydi-hero__progress');
        this.progressAnimation = progress.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: this.interval, fill: 'forwards' });
        this.timer = setTimeout(() => this.go(this.index + 1), this.interval);
      }
      async go(requested, manual = false, instant = false) {
        if (manual) this.userPaused = true;
        const nextIndex = (requested + this.slides.length) % this.slides.length;
        if (this.busy || nextIndex === this.index) { this.schedule(); return; }
        this.stop();
        this.busy = true;
        const outgoing = this.slides[this.index];
        const incoming = this.slides[nextIndex];
        outgoing.inert = true;
        outgoing.setAttribute('aria-hidden', 'true');
        incoming.inert = false;
        incoming.removeAttribute('aria-hidden');
        incoming.classList.add('is-active');
        incoming.style.zIndex = '2';
        const animations = [];
        if (!this.motion.matches && !instant) {
          const options = { duration: 850, easing: 'cubic-bezier(0.76, 0, 0.24, 1)', fill: 'both' };
          animations.push(incoming.animate([{ clipPath: 'inset(0 100% 0 0)' }, { clipPath: 'inset(0 0% 0 0)' }], options));
          animations.push(incoming.querySelector('.leydi-hero__media').animate([{ transform: 'translateX(-18%) scale(1.08)' }, { transform: 'translateX(0) scale(1)' }], options));
          await Promise.all(animations.map(animation => animation.finished.catch(() => {})));
        }
        if (!this.isConnected) return;
        outgoing.classList.remove('is-active');
        incoming.style.zIndex = '';
        animations.forEach(animation => animation.cancel());
        this.index = nextIndex;
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
        if (manual) this.querySelector('.leydi-hero__status').textContent = incoming.getAttribute('aria-label');
        this.busy = false;
        this.schedule();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let underlay;
    let cover;
    let observer;
    let frame;
    const measure = () => {
      if (underlay) {
        underlay.style.setProperty('--leydi-overlay-top', Math.min(0, window.innerHeight - underlay.offsetHeight) + 'px');
      }
    };
    const setup = () => {
      if (observer) observer.disconnect();
      if (underlay) {
        underlay.removeAttribute('data-leydi-overlay-underlay');
        underlay.style.removeProperty('--leydi-overlay-top');
      }
      if (cover) cover.removeAttribute('data-leydi-overlay-cover');
      underlay = undefined;
      cover = undefined;
      if (motion.matches) return;
      const target = document.querySelector('#MainContent > [id$="__a2cb1db7-2442-4abb-aaaa-4d54606c1c58"]');
      if (!target || !target.querySelector('.rich-text')) return;
      let previous = target.previousElementSibling;
      while (previous && (previous.hidden || previous.offsetHeight === 0)) previous = previous.previousElementSibling;
      if (!previous) return;
      underlay = previous;
      cover = target;
      underlay.setAttribute('data-leydi-overlay-underlay', '');
      cover.setAttribute('data-leydi-overlay-cover', '');
      measure();
      observer = new ResizeObserver(measure);
      observer.observe(underlay);
    };
    const refresh = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(setup);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
    else setup();
    window.addEventListener('resize', measure, { passive: true });
    motion.addEventListener('change', refresh);
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('shopify:section:unload', refresh);
    document.addEventListener('shopify:section:reorder', refresh);
  })();

  } catch(e) { console.error(e); }
})();
})();
